export const DMS_MODULE = 'Administrace';
